(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementBar {
    constructor(root) {
      this.root = root;
      this.viewport = root.querySelector('[data-announcement-viewport]');
      this.track = root.querySelector('[data-announcement-track]');
      this.group = root.querySelector('[data-announcement-group]');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.speed = Number(root.dataset.scrollSpeed) || 50;
      this.offset = 0;
      this.lastTime = null;
      this.rafId = null;
      this.loopDistance = 0;
      this.inViewport = true;
      this.tick = this.tick.bind(this);
      this.onResize = this.handleResize.bind(this);
      this.onVisibilityChange = this.handleVisibilityChange.bind(this);
      this.updateAnimationState = this.updateAnimationState.bind(this);

      if (!this.viewport || !this.track || !this.group) return;

      if (this.reducedMotion) return;

      this.setup();
      window.addEventListener('resize', this.onResize, { passive: true });
      document.addEventListener('visibilitychange', this.onVisibilityChange);
      document.fonts?.ready?.then(() => this.setup());

      this.viewportObserver = new IntersectionObserver(
        (entries) => {
          this.inViewport = entries[0]?.isIntersecting ?? false;
          this.updateAnimationState();
        },
        { threshold: 0 }
      );

      this.viewportObserver.observe(this.root);
      this.updateAnimationState();
    }

    setup() {
      this.ensureClones();
      this.normalizeOffset();
      this.applyTransform();
    }

    ensureClones() {
      const template = this.group;
      const loopDistance = template.getBoundingClientRect().width;

      if (!loopDistance) return;

      const viewportWidth = this.viewport.getBoundingClientRect().width;
      const minGroups = Math.max(2, Math.ceil((viewportWidth + loopDistance) / loopDistance));

      while (this.track.children.length > 1) {
        this.track.lastElementChild.remove();
      }

      for (let index = 1; index < minGroups; index += 1) {
        const clone = template.cloneNode(true);
        clone.removeAttribute('data-announcement-group');
        clone.setAttribute('aria-hidden', 'true');
        this.track.appendChild(clone);
      }

      this.loopDistance = loopDistance;
    }

    normalizeOffset() {
      if (!this.loopDistance) return;

      while (this.offset <= -this.loopDistance) {
        this.offset += this.loopDistance;
      }

      while (this.offset > 0) {
        this.offset -= this.loopDistance;
      }
    }

    applyTransform() {
      this.track.style.transform = `translate3d(${this.offset}px, 0, 0)`;
    }

    handleResize() {
      const previousDistance = this.loopDistance;
      this.setup();

      if (previousDistance && this.loopDistance && previousDistance !== this.loopDistance) {
        this.offset = (this.offset / previousDistance) * this.loopDistance;
        this.normalizeOffset();
        this.applyTransform();
      }
    }

    handleVisibilityChange() {
      if (!document.hidden) {
        this.lastTime = null;
      }

      this.updateAnimationState();
    }

    updateAnimationState() {
      const shouldRun = this.inViewport && !document.hidden;

      if (shouldRun && !this.rafId) {
        this.lastTime = null;
        this.rafId = requestAnimationFrame(this.tick);
        return;
      }

      if (!shouldRun && this.rafId) {
        cancelAnimationFrame(this.rafId);
        this.rafId = null;
        this.lastTime = null;
      }
    }

    tick(time) {
      if (!this.inViewport || document.hidden) {
        this.rafId = null;
        return;
      }

      if (!this.loopDistance) {
        this.setup();
        this.rafId = requestAnimationFrame(this.tick);
        return;
      }

      if (this.lastTime !== null) {
        const delta = Math.min((time - this.lastTime) / 1000, 0.05);
        this.offset -= this.speed * delta;

        while (this.offset <= -this.loopDistance) {
          this.offset += this.loopDistance;
        }

        this.applyTransform();
      }

      this.lastTime = time;
      this.rafId = requestAnimationFrame(this.tick);
    }

    disconnect() {
      window.removeEventListener('resize', this.onResize);
      document.removeEventListener('visibilitychange', this.onVisibilityChange);
      this.viewportObserver?.disconnect();

      if (this.rafId) {
        cancelAnimationFrame(this.rafId);
        this.rafId = null;
      }
    }
  }

  const bars = new WeakMap();

  function initAnnouncementBars() {
    document.querySelectorAll('[data-announcement-bar]').forEach((root) => {
      if (bars.has(root)) {
        bars.get(root).disconnect();
      }

      bars.set(root, new AnnouncementBar(root));
    });
  }

  initAnnouncementBars();
  document.addEventListener('shopify:section:load', initAnnouncementBars);
  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target.querySelector('[data-announcement-bar]');

    if (root && bars.has(root)) {
      bars.get(root).disconnect();
      bars.delete(root);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["benefits"] && !Shopify.designMode) return;
  try {
    
  class BenefitsSection {
    constructor(section) {
      this.section = section;
      this.header = section.querySelector('[data-benefits-header]');
      this.cards = Array.from(section.querySelectorAll('[data-benefits-card]'));
      this.observer = null;

      if (!this.cards.length) return;

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.revealAll();
        return;
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            this.observer.unobserve(entry.target);
          });
        },
        {
          threshold: 0.15,
          rootMargin: '0px 0px -6% 0px',
        }
      );

      if (this.header) {
        this.observer.observe(this.header);
      }

      this.cards.forEach((card, index) => {
        card.style.transitionDelay = `${index * 70}ms`;
        this.observer.observe(card);
      });
    }

    revealAll() {
      this.header?.classList.add('is-visible');
      this.cards.forEach((card) => card.classList.add('is-visible'));
    }

    disconnect() {
      this.observer?.disconnect();
    }
  }

  const benefitsSections = new WeakMap();

  function initBenefitsSections() {
    document.querySelectorAll('.benefits').forEach((section) => {
      if (benefitsSections.has(section)) {
        benefitsSections.get(section).disconnect();
      }

      benefitsSections.set(section, new BenefitsSection(section));
    });
  }

  initBenefitsSections();
  document.addEventListener('shopify:section:load', initBenefitsSections);
  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target.querySelector('.benefits');

    if (section && benefitsSections.has(section)) {
      benefitsSections.get(section).disconnect();
      benefitsSections.delete(section);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["comparative-table"] && !Shopify.designMode) return;
  try {
    
  class ComparativeTableSection {
    constructor(section) {
      this.section = section;
      this.header = section.querySelector('[data-comparative-header]');
      this.card = section.querySelector('[data-comparative-card]');
      this.rows = Array.from(section.querySelectorAll('[data-comparative-row]'));
      this.verdicts = Array.from(section.querySelectorAll('[data-comparative-verdict]'));
      this.observer = null;

      if (!this.card && !this.header && this.verdicts.length === 0) return;

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.revealAll();
        return;
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            this.observer.unobserve(entry.target);
          });
        },
        {
          threshold: 0.1,
          rootMargin: '0px 0px -6% 0px',
        }
      );

      if (this.header) this.observer.observe(this.header);
      if (this.card) this.observer.observe(this.card);

      this.rows.forEach((row, index) => {
        row.style.transitionDelay = `${180 + index * 45}ms`;
        this.observer.observe(row);
      });

      this.verdicts.forEach((card, index) => {
        card.style.transitionDelay = `${120 + index * 50}ms`;
        this.observer.observe(card);
      });
    }

    revealAll() {
      this.header?.classList.add('is-visible');
      this.card?.classList.add('is-visible');
      this.rows.forEach((row) => row.classList.add('is-visible'));
      this.verdicts.forEach((card) => card.classList.add('is-visible'));
    }

    disconnect() {
      this.observer?.disconnect();
    }
  }

  const comparativeTableSections = new WeakMap();

  function initComparativeTableSections() {
    document.querySelectorAll('.comparative-table').forEach((section) => {
      if (comparativeTableSections.has(section)) {
        comparativeTableSections.get(section).disconnect();
      }

      comparativeTableSections.set(section, new ComparativeTableSection(section));
    });
  }

  initComparativeTableSections();
  document.addEventListener('shopify:section:load', initComparativeTableSections);
  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target.querySelector('.comparative-table');

    if (section && comparativeTableSections.has(section)) {
      comparativeTableSections.get(section).disconnect();
      comparativeTableSections.delete(section);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  class FaqAccordion {
    constructor(root) {
      this.root = root;
      this.items = Array.from(root.querySelectorAll('[data-faq-item]'));
      this.duration = 450;
      this.onClick = this.onClick.bind(this);
      root.addEventListener('click', this.onClick);
      this.syncAccessibility();
    }

    onClick(event) {
      const trigger = event.target.closest('[data-faq-trigger]');
      if (!trigger || !this.root.contains(trigger)) return;

      const item = trigger.closest('[data-faq-item]');
      const isOpen = item.classList.contains('is-open');

      this.items.forEach((entry) => {
        if (entry !== item || isOpen) {
          this.closeItem(entry);
        }
      });

      if (!isOpen) {
        this.openItem(item);
      }
    }

    openItem(item) {
      const panel = item.querySelector('.faq__answer');
      const trigger = item.querySelector('[data-faq-trigger]');

      panel.removeAttribute('hidden');
      panel.removeAttribute('inert');

      requestAnimationFrame(() => {
        item.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      });
    }

    closeItem(item) {
      if (!item.classList.contains('is-open')) return;

      const panel = item.querySelector('.faq__answer');
      const trigger = item.querySelector('[data-faq-trigger]');

      item.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      panel.setAttribute('inert', '');

      window.setTimeout(() => {
        if (!item.classList.contains('is-open')) {
          panel.setAttribute('hidden', '');
        }
      }, this.duration);
    }

    syncAccessibility() {
      this.items.forEach((item) => {
        const panel = item.querySelector('.faq__answer');
        const trigger = item.querySelector('[data-faq-trigger]');
        const isOpen = item.classList.contains('is-open');

        trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

        if (isOpen) {
          panel.removeAttribute('hidden');
          panel.removeAttribute('inert');
        } else {
          panel.setAttribute('hidden', '');
          panel.setAttribute('inert', '');
        }
      });
    }

    disconnect() {
      this.root.removeEventListener('click', this.onClick);
    }
  }

  const faqAccordions = new WeakMap();

  function initFaqAccordions() {
    document.querySelectorAll('[data-faq-accordion]').forEach((root) => {
      if (faqAccordions.has(root)) {
        faqAccordions.get(root).disconnect();
      }

      faqAccordions.set(root, new FaqAccordion(root));
    });
  }

  initFaqAccordions();
  document.addEventListener('shopify:section:load', initFaqAccordions);
  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target.querySelector('[data-faq-accordion]');

    if (root && faqAccordions.has(root)) {
      faqAccordions.get(root).disconnect();
      faqAccordions.delete(root);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderScroll {
    constructor(header) {
      this.header = header;
      this.spacer = header.nextElementSibling?.matches('[data-header-spacer]')
        ? header.nextElementSibling
        : null;
      this.announcementBar = document.querySelector('[data-announcement-bar]');
      this.threshold = 12;
      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onResize.bind(this);

      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize, { passive: true });

      if (typeof ResizeObserver !== 'undefined') {
        this.resizeObserver = new ResizeObserver(() => this.measure());
        this.resizeObserver.observe(this.header);
      }

      this.measure();
      this.onScroll();
    }

    measure() {
      const inner = this.header.querySelector('.header__inner');
      const height = inner?.offsetHeight || this.header.offsetHeight;

      document.documentElement.style.setProperty('--header-height', `${height}px`);

      if (this.spacer) {
        this.spacer.style.height = `${height}px`;
      }
    }

    onResize() {
      this.measure();
      this.onScroll();
    }

    onScroll() {
      const scrolled = window.scrollY > this.threshold;
      this.header.classList.toggle('is-scrolled', scrolled);

      let offsetTop = 0;

      if (this.announcementBar) {
        const announcementBottom = this.announcementBar.getBoundingClientRect().bottom;
        offsetTop = Math.max(0, announcementBottom);
      }

      this.header.style.setProperty('--header-offset-top', `${offsetTop}px`);
    }

    disconnect() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
      this.resizeObserver?.disconnect();
      this.resizeObserver = null;
    }
  }

  class HeaderMenu {
    constructor(header) {
      this.header = header;
      this.toggle = header.querySelector('[data-header-menu-toggle]');
      this.nav = header.querySelector('[data-header-mobile-nav]');
      this.onToggle = this.onToggle.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onResize = this.onResize.bind(this);

      if (!this.toggle || !this.nav) return;

      this.toggle.addEventListener('click', this.onToggle);
      document.addEventListener('keydown', this.onKeydown);
      window.addEventListener('resize', this.onResize, { passive: true });
    }

    onToggle() {
      const isOpen = this.header.classList.toggle('is-menu-open');
      this.toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      this.toggle.setAttribute(
        'aria-label',
        isOpen
          ? this.toggle.dataset.closeLabel
          : this.toggle.dataset.openLabel
      );
      this.nav.toggleAttribute('hidden', !isOpen);
    }

    onKeydown(event) {
      if (event.key === 'Escape' && this.header.classList.contains('is-menu-open')) {
        this.close();
      }
    }

    onResize() {
      if (window.innerWidth >= 1320 && this.header.classList.contains('is-menu-open')) {
        this.close();
      }
    }

    close() {
      this.header.classList.remove('is-menu-open');
      this.toggle.setAttribute('aria-expanded', 'false');
      this.nav.setAttribute('hidden', '');
    }

    disconnect() {
      this.toggle?.removeEventListener('click', this.onToggle);
      document.removeEventListener('keydown', this.onKeydown);
      window.removeEventListener('resize', this.onResize);
    }
  }

  const headerMenus = new WeakMap();
  const headerScrolls = new WeakMap();

  function initHeaderMenus() {
    document.querySelectorAll('.header').forEach((header) => {
      if (headerMenus.has(header)) {
        headerMenus.get(header).disconnect();
      }

      if (headerScrolls.has(header)) {
        headerScrolls.get(header).disconnect();
      }

      headerMenus.set(header, new HeaderMenu(header));
      headerScrolls.set(header, new HeaderScroll(header));
    });
  }

  initHeaderMenus();
  document.addEventListener('shopify:section:load', initHeaderMenus);
  document.addEventListener('shopify:section:unload', (event) => {
    const header = event.target.querySelector('.header');

    if (header && headerMenus.has(header)) {
      headerMenus.get(header).disconnect();
      headerMenus.delete(header);
    }

    if (header && headerScrolls.has(header)) {
      headerScrolls.get(header).disconnect();
      headerScrolls.delete(header);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-it-works"] && !Shopify.designMode) return;
  try {
    
  class HowItWorksSection {
    constructor(section) {
      this.section = section;
      this.header = section.querySelector('[data-how-it-works-header]');
      this.steps = Array.from(section.querySelectorAll('[data-how-it-works-step]'));
      this.observer = null;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (!this.steps.length) return;

      if (this.reducedMotion) {
        this.revealAll();
        return;
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;

            entry.target.classList.add('is-visible');
            this.observer.unobserve(entry.target);
          });
        },
        {
          threshold: 0.15,
          rootMargin: '0px 0px -6% 0px',
        }
      );

      if (this.header) {
        this.observer.observe(this.header);
      }

      this.steps.forEach((step, index) => {
        step.style.transitionDelay = `${index * 80}ms`;
        this.observer.observe(step);
      });
    }

    revealAll() {
      this.header?.classList.add('is-visible');
      this.steps.forEach((step) => step.classList.add('is-visible'));
    }

    disconnect() {
      this.observer?.disconnect();
    }
  }

  const howItWorksSections = new WeakMap();

  function initHowItWorksSections() {
    document.querySelectorAll('.how-it-works').forEach((section) => {
      if (howItWorksSections.has(section)) {
        howItWorksSections.get(section).disconnect();
      }

      howItWorksSections.set(section, new HowItWorksSection(section));
    });
  }

  initHowItWorksSections();
  document.addEventListener('shopify:section:load', initHowItWorksSections);
  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target.querySelector('.how-it-works');

    if (section && howItWorksSections.has(section)) {
      howItWorksSections.get(section).disconnect();
      howItWorksSections.delete(section);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["join-now"] && !Shopify.designMode) return;
  try {
    
  class JoinNowSection {
    constructor(section) {
      this.section = section;
      this.panel = section.querySelector('[data-join-now-panel]');
      this.perks = Array.from(section.querySelectorAll('.join-now__perk'));
      this.steps = Array.from(section.querySelectorAll('[data-join-now-step]'));
      this.observer = null;

      if (!this.panel) return;

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.revealAll();
        return;
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            this.observer.unobserve(entry.target);
          });
        },
        {
          threshold: 0.12,
          rootMargin: '0px 0px -8% 0px',
        }
      );

      this.observer.observe(this.panel);

      this.perks.forEach((perk, index) => {
        perk.style.transitionDelay = `${180 + index * 80}ms`;
        this.observer.observe(perk);
      });

      this.steps.forEach((step, index) => {
        step.style.transitionDelay = `${320 + index * 90}ms`;
        this.observer.observe(step);
      });
    }

    revealAll() {
      this.panel?.classList.add('is-visible');
      this.perks.forEach((perk) => perk.classList.add('is-visible'));
      this.steps.forEach((step) => step.classList.add('is-visible'));
    }

    disconnect() {
      this.observer?.disconnect();
    }
  }

  const joinNowSections = new WeakMap();

  function initJoinNowSections() {
    document.querySelectorAll('.join-now').forEach((section) => {
      if (joinNowSections.has(section)) {
        joinNowSections.get(section).disconnect();
      }

      joinNowSections.set(section, new JoinNowSection(section));
    });
  }

  initJoinNowSections();
  document.addEventListener('shopify:section:load', initJoinNowSections);
  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target.querySelector('.join-now');

    if (section && joinNowSections.has(section)) {
      joinNowSections.get(section).disconnect();
      joinNowSections.delete(section);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["members"] && !Shopify.designMode) return;
  try {
    
  class MembersCarousel {
    constructor(root) {
      this.root = root;
      this.viewport = root.querySelector('[data-members-viewport]');
      this.track = root.querySelector('[data-members-track]');
      this.group = root.querySelector('[data-members-group]');
      this.speed = Number(root.dataset.scrollSpeed) || 30;
      this.phase = 0.2;
      this.offset = 0;
      this.hasInitialized = false;
      this.lastTime = null;
      this.rafId = null;
      this.loopDistance = 0;
      this.inViewport = true;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.tick = this.tick.bind(this);
      this.onResize = this.handleResize.bind(this);
      this.onVisibilityChange = this.handleVisibilityChange.bind(this);
      this.updateAnimationState = this.updateAnimationState.bind(this);

      if (!this.viewport || !this.track || !this.group || this.reducedMotion) return;

      this.setup();
      window.addEventListener('resize', this.onResize, { passive: true });
      document.addEventListener('visibilitychange', this.onVisibilityChange);
      document.fonts?.ready?.then(() => this.setup());

      this.viewportObserver = new IntersectionObserver(
        (entries) => {
          this.inViewport = entries[0]?.isIntersecting ?? false;
          this.updateAnimationState();
        },
        { threshold: 0 }
      );

      this.viewportObserver.observe(this.root);
      this.updateAnimationState();
    }

    setup() {
      this.ensureClones();
      this.applyPhaseOffset();
      this.normalizeOffset();
      this.applyTransform();
    }

    applyPhaseOffset() {
      if (!this.loopDistance || this.hasInitialized) return;

      this.offset = -this.loopDistance * this.phase;
      this.hasInitialized = true;
    }

    measureLoopDistance(template) {
      const siblings = Array.from(this.track.children);
      const templateIndex = siblings.indexOf(template);

      if (templateIndex !== -1 && siblings[templateIndex + 1]) {
        return siblings[templateIndex + 1].offsetLeft - template.offsetLeft;
      }

      return template.getBoundingClientRect().width;
    }

    ensureClones() {
      const template = this.group;
      const groupWidth = template.getBoundingClientRect().width;

      if (!groupWidth) return;

      const viewportWidth = this.viewport.getBoundingClientRect().width;
      const minGroups = Math.max(2, Math.ceil((viewportWidth + groupWidth) / groupWidth));

      while (this.track.children.length > 1) {
        this.track.lastElementChild.remove();
      }

      for (let index = 1; index < minGroups; index += 1) {
        const clone = template.cloneNode(true);
        clone.removeAttribute('data-members-group');
        clone.setAttribute('aria-hidden', 'true');
        this.track.appendChild(clone);
      }

      this.loopDistance = this.measureLoopDistance(template);
    }

    normalizeOffset() {
      if (!this.loopDistance) return;

      while (this.offset <= -this.loopDistance) {
        this.offset += this.loopDistance;
      }

      while (this.offset > 0) {
        this.offset -= this.loopDistance;
      }
    }

    applyTransform() {
      this.track.style.transform = `translate3d(${this.offset}px, 0, 0)`;
    }

    handleResize() {
      const previousDistance = this.loopDistance;
      const previousRatio = previousDistance ? this.offset / previousDistance : 0;

      this.ensureClones();

      if (previousDistance && this.loopDistance) {
        this.offset = previousRatio * this.loopDistance;
      }

      this.normalizeOffset();
      this.applyTransform();
    }

    handleVisibilityChange() {
      if (!document.hidden) {
        this.lastTime = null;
      }

      this.updateAnimationState();
    }

    updateAnimationState() {
      const shouldRun = this.inViewport && !document.hidden;

      if (shouldRun && !this.rafId) {
        this.lastTime = null;
        this.rafId = requestAnimationFrame(this.tick);
        return;
      }

      if (!shouldRun && this.rafId) {
        cancelAnimationFrame(this.rafId);
        this.rafId = null;
        this.lastTime = null;
      }
    }

    tick(time) {
      if (!this.inViewport || document.hidden) {
        this.rafId = null;
        return;
      }

      if (!this.loopDistance) {
        this.setup();
        this.rafId = requestAnimationFrame(this.tick);
        return;
      }

      if (this.lastTime !== null) {
        const delta = Math.min((time - this.lastTime) / 1000, 0.05);
        this.offset -= this.speed * delta;

        while (this.offset <= -this.loopDistance) {
          this.offset += this.loopDistance;
        }

        this.applyTransform();
      }

      this.lastTime = time;
      this.rafId = requestAnimationFrame(this.tick);
    }

    disconnect() {
      window.removeEventListener('resize', this.onResize);
      document.removeEventListener('visibilitychange', this.onVisibilityChange);
      this.viewportObserver?.disconnect();

      if (this.rafId) {
        cancelAnimationFrame(this.rafId);
        this.rafId = null;
      }
    }
  }

  const membersCarousels = new WeakMap();

  function initMembersCarousels() {
    document.querySelectorAll('[data-members-carousel]').forEach((root) => {
      if (membersCarousels.has(root)) {
        membersCarousels.get(root).disconnect();
      }

      const carousel = new MembersCarousel(root);

      membersCarousels.set(root, carousel);
    });
  }

  initMembersCarousels();
  document.addEventListener('shopify:section:load', initMembersCarousels);
  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target.querySelector('[data-members-carousel]');

    if (root && membersCarousels.has(root)) {
      membersCarousels.get(root).disconnect();
      membersCarousels.delete(root);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup-bar"] && !Shopify.designMode) return;
  try {
    
  class PopupBar {
    constructor(root) {
      this.root = root;
      this.anchorId = root.dataset.pricingAnchor || 'pricing';
      this.pricing = document.getElementById(this.anchorId);
      this.exitOffset = Number(root.dataset.exitOffset) || 100;
      this.isHidden = true;
      this.rafId = null;
      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onScroll.bind(this);

      if (!this.pricing) {
        this.setHidden(true);
        return;
      }

      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize, { passive: true });
      this.onScroll();
    }

    shouldHide() {
      const rect = this.pricing.getBoundingClientRect();

      // Show only after the user has scrolled past the end of Pricing
      // (same post-pricing visibility as before; hidden on early sections).
      return !(rect.bottom < this.exitOffset);
    }

    setHidden(hide) {
      this.isHidden = hide;
      this.root.classList.toggle('is-hidden', hide);
      this.root.setAttribute('aria-hidden', hide ? 'true' : 'false');
    }

    onScroll() {
      if (this.rafId) return;

      this.rafId = requestAnimationFrame(() => {
        this.rafId = null;

        const hide = this.shouldHide();

        if (hide === this.isHidden) return;

        this.setHidden(hide);
      });
    }

    disconnect() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);

      if (this.rafId) {
        cancelAnimationFrame(this.rafId);
        this.rafId = null;
      }
    }
  }

  const popupBars = new WeakMap();

  function initPopupBars() {
    document.querySelectorAll('[data-popup-bar]').forEach((root) => {
      if (popupBars.has(root)) {
        popupBars.get(root).disconnect();
      }

      popupBars.set(root, new PopupBar(root));
    });
  }

  initPopupBars();
  document.addEventListener('shopify:section:load', initPopupBars);
  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target.querySelector('[data-popup-bar]');

    if (root && popupBars.has(root)) {
      popupBars.get(root).disconnect();
      popupBars.delete(root);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pricing"] && !Shopify.designMode) return;
  try {
    
  class PricingStickyGallery {
    constructor(section) {
      this.section = section;
      this.galleryColumn = section.querySelector('.pricing__gallery-column');
      this.contentColumn = section.querySelector('.pricing__content-column');
      this.mediaQuery = window.matchMedia('(min-width: 990px)');

      if (!this.galleryColumn || !this.contentColumn) return;

      this.syncHeights = this.syncHeights.bind(this);
      this.onMediaChange = this.onMediaChange.bind(this);

      this.resizeObserver = new ResizeObserver(this.syncHeights);
      this.resizeObserver.observe(this.contentColumn);

      if (this.mediaQuery.addEventListener) {
        this.mediaQuery.addEventListener('change', this.onMediaChange);
      } else {
        this.mediaQuery.addListener(this.onMediaChange);
      }

      window.addEventListener('resize', this.syncHeights);
      this.syncHeights();
    }

    onMediaChange() {
      this.syncHeights();
    }

    syncHeights() {
      if (!this.mediaQuery.matches) {
        this.galleryColumn.style.minHeight = '';
        return;
      }

      this.galleryColumn.style.minHeight = `${this.contentColumn.offsetHeight}px`;
    }

    disconnect() {
      this.resizeObserver?.disconnect();
      window.removeEventListener('resize', this.syncHeights);

      if (this.mediaQuery.removeEventListener) {
        this.mediaQuery.removeEventListener('change', this.onMediaChange);
      } else {
        this.mediaQuery.removeListener(this.onMediaChange);
      }

      if (this.galleryColumn) {
        this.galleryColumn.style.minHeight = '';
      }
    }
  }

  const pricingStickyGalleries = new WeakMap();

  function initPricingStickyGalleries() {
    document.querySelectorAll('.pricing-section').forEach((section) => {
      if (pricingStickyGalleries.has(section)) return;
      pricingStickyGalleries.set(section, new PricingStickyGallery(section));
    });
  }

  class PricingGallery {
    constructor(section) {
      this.section = section;
      this.root = section.querySelector('[data-pricing-gallery]');

      if (!this.root) return;

      this.stage = this.root.querySelector('[data-pricing-gallery-stage]');
      this.slides = Array.from(this.root.querySelectorAll('[data-pricing-gallery-slide]'));
      this.thumbs = Array.from(this.root.querySelectorAll('[data-pricing-gallery-thumb]'));
      this.prevButton = this.root.querySelector('[data-pricing-gallery-prev]');
      this.nextButton = this.root.querySelector('[data-pricing-gallery-next]');
      this.counterCurrent = this.root.querySelector('[data-pricing-gallery-counter-current]');
      this.activeIndex = 0;
      this.tierSyncEnabled = this.root.dataset.pricingGalleryTierSync === 'true';
      this.pointerStartX = null;
      this.pointerDeltaX = 0;

      this.onThumbClick = this.onThumbClick.bind(this);
      this.onPrevClick = this.onPrevClick.bind(this);
      this.onNextClick = this.onNextClick.bind(this);
      this.onKeyDown = this.onKeyDown.bind(this);
      this.onPointerDown = this.onPointerDown.bind(this);
      this.onPointerMove = this.onPointerMove.bind(this);
      this.onPointerUp = this.onPointerUp.bind(this);

      this.thumbs.forEach((thumb) => thumb.addEventListener('click', this.onThumbClick));
      this.prevButton?.addEventListener('click', this.onPrevClick);
      this.nextButton?.addEventListener('click', this.onNextClick);
      this.stage?.addEventListener('keydown', this.onKeyDown);

      if (this.stage && this.slides.length > 1) {
        this.stage.addEventListener('pointerdown', this.onPointerDown);
        this.stage.addEventListener('pointermove', this.onPointerMove);
        this.stage.addEventListener('pointerup', this.onPointerUp);
        this.stage.addEventListener('pointercancel', this.onPointerUp);
      }

      this.setActive(0, false);
    }

    onThumbClick(event) {
      const thumb = event.currentTarget;
      const index = Number(thumb.dataset.pricingGalleryIndex || 0);
      this.setActive(index, true);
    }

    onPrevClick(event) {
      event.preventDefault();
      this.step(-1);
    }

    onNextClick(event) {
      event.preventDefault();
      this.step(1);
    }

    onKeyDown(event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        this.step(-1);
      }

      if (event.key === 'ArrowRight') {
        event.preventDefault();
        this.step(1);
      }
    }

    onPointerDown(event) {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      if (event.target.closest('.pricing__gallery-nav')) return;

      this.pointerStartX = event.clientX;
      this.pointerDeltaX = 0;
      this.stage?.setPointerCapture?.(event.pointerId);
    }

    onPointerMove(event) {
      if (this.pointerStartX === null) return;
      this.pointerDeltaX = event.clientX - this.pointerStartX;
    }

    onPointerUp() {
      if (this.pointerStartX === null) return;

      const threshold = 48;

      if (this.pointerDeltaX <= -threshold) {
        this.step(1);
      } else if (this.pointerDeltaX >= threshold) {
        this.step(-1);
      }

      this.pointerStartX = null;
      this.pointerDeltaX = 0;
    }

    step(direction) {
      if (!this.slides.length) return;

      const nextIndex = (this.activeIndex + direction + this.slides.length) % this.slides.length;
      this.setActive(nextIndex, true);
    }

    setActive(index, fromUser) {
      if (!this.slides.length) return;

      const safeIndex = Math.max(0, Math.min(index, this.slides.length - 1));

      if (safeIndex === this.activeIndex && fromUser !== true) {
        this.updateChrome();
        return;
      }

      this.activeIndex = safeIndex;

      this.slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === safeIndex;
        slide.classList.toggle('is-active', isActive);
      });

      this.thumbs.forEach((thumb) => {
        const thumbIndex = Number(thumb.dataset.pricingGalleryIndex || 0);
        const isActive = thumbIndex === safeIndex;
        thumb.classList.toggle('is-active', isActive);
        thumb.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      this.updateChrome();
      this.scrollActiveThumbIntoView(fromUser);
    }

    updateChrome() {
      if (this.counterCurrent) {
        this.counterCurrent.textContent = String(this.activeIndex + 1);
      }
    }

    scrollActiveThumbIntoView(fromUser) {
      if (!fromUser) return;

      const activeThumb = this.thumbs.find(
        (thumb) => Number(thumb.dataset.pricingGalleryIndex || 0) === this.activeIndex
      );

      activeThumb?.scrollIntoView({
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        inline: 'center',
        block: 'nearest',
      });
    }

    disconnect() {
      this.thumbs.forEach((thumb) => thumb.removeEventListener('click', this.onThumbClick));
      this.prevButton?.removeEventListener('click', this.onPrevClick);
      this.nextButton?.removeEventListener('click', this.onNextClick);
      this.stage?.removeEventListener('keydown', this.onKeyDown);
      this.stage?.removeEventListener('pointerdown', this.onPointerDown);
      this.stage?.removeEventListener('pointermove', this.onPointerMove);
      this.stage?.removeEventListener('pointerup', this.onPointerUp);
      this.stage?.removeEventListener('pointercancel', this.onPointerUp);
    }
  }

  const pricingGalleries = new WeakMap();

  function initPricingGalleries() {
    document.querySelectorAll('.pricing-section').forEach((section) => {
      if (pricingGalleries.has(section)) return;
      pricingGalleries.set(section, new PricingGallery(section));
    });
  }

  class PricingBuybox {
    constructor(root, gallery) {
      this.root = root;
      this.gallery = gallery || null;
      this.form = root.querySelector('.pricing__form');
      this.quantities = Array.from(root.querySelectorAll('[data-pricing-quantity]'));
      this.purchaseTypes = Array.from(root.querySelectorAll('[data-pricing-purchase-type]'));
      this.variantInput = root.querySelector('[data-pricing-variant-input]');
      this.quantityInput = root.querySelector('[data-pricing-quantity-input]');
      this.sellingPlanInput = root.querySelector('[data-pricing-selling-plan-input]');
      this.submitButton = root.querySelector('[data-pricing-submit]');
      this.submitLabel = root.querySelector('[data-pricing-submit-label]');
      this.submitSpinner = root.querySelector('[data-pricing-submit-spinner]');
      this.stockNote = root.closest('.pricing__content')?.querySelector('[data-pricing-stock-note]');
      this.displayPrice = root.querySelector('[data-pricing-display-price]');
      this.displayPeriod = root.querySelector('[data-pricing-display-period]');
      this.displayPerDay = root.querySelector('[data-pricing-display-per-day]');
      this.totalLine = root.querySelector('[data-pricing-total-line]');
      this.toggleSubscribeLabel = root.querySelector('[data-pricing-toggle-subscribe-label]');
      this.toggleSaveHint = root.querySelector('[data-pricing-toggle-save-hint]');
      this.benefitsHeading = root.querySelector('[data-pricing-benefits-heading]');
      this.guaranteeText = root.querySelector('[data-pricing-guarantee-text]');
      this.guaranteeBenefits = Array.from(root.querySelectorAll('[data-pricing-guarantee-benefit]'));
      this.afterAdd = root.dataset.afterAdd || 'drawer';
      this.fallbackLink = root.dataset.fallbackLink || '';
      this.subscribeLabel = root.dataset.subscribeLabel || 'Subscribe & save';
      this.onetimeLabel = root.dataset.onetimeLabel || 'Buy one time';
      this.subscribeToggleLabel = root.dataset.subscribeToggleLabel || 'Subscribe & save';
      this.addingLabel = root.dataset.addingLabel || 'Adding...';
      this.addedLabel = root.dataset.addedLabel || 'Added to cart';
      this.errorLabel = root.dataset.errorLabel || 'Something went wrong. Try again.';
      this.totalLabel = root.dataset.totalLabel || 'Total';
      this.saveLabelTemplate = root.dataset.saveLabelTemplate || 'Save __AMOUNT__';
      this.perDaySuffix = root.dataset.perDaySuffix || '/day';
      this.guaranteeTextTemplate = root.dataset.guaranteeTextTemplate || '';
      this.purchaseType = root.dataset.enableSubscription === 'false' ? 'onetime' : 'subscribe';

      this.onQuantityClick = this.onQuantityClick.bind(this);
      this.onQuantityKeydown = this.onQuantityKeydown.bind(this);
      this.onPurchaseTypeClick = this.onPurchaseTypeClick.bind(this);
      this.onSubmit = this.onSubmit.bind(this);

      if (!this.quantities.length) return;

      this.quantities.forEach((quantity) => {
        quantity.addEventListener('click', this.onQuantityClick);

        if (!quantity.hasAttribute('tabindex')) {
          quantity.setAttribute('tabindex', quantity.classList.contains('is-selected') ? '0' : '-1');
        }

        quantity.addEventListener('keydown', this.onQuantityKeydown);
      });

      this.purchaseTypes.forEach((option) => {
        option.addEventListener('click', this.onPurchaseTypeClick);
      });

      if (this.form) {
        this.form.addEventListener('submit', this.onSubmit);
      }

      const initialQuantity =
        this.quantities.find((quantity) => quantity.classList.contains('is-selected')) ||
        this.quantities[0];
      this.selectQuantity(initialQuantity, false);
      this.updatePurchaseUI();
    }

    getSelectedQuantity() {
      return this.quantities.find((quantity) => quantity.classList.contains('is-selected'));
    }

    isQuantitySelectable(quantity) {
      if (!quantity) return false;

      if (
        quantity.dataset.subscribeVariantId ||
        quantity.dataset.onetimeVariantId ||
        quantity.dataset.variantId ||
        quantity.dataset.tierLink
      ) {
        return true;
      }

      return !quantity.classList.contains('is-unavailable');
    }

    onQuantityClick(event) {
      const quantity = event.currentTarget.closest('[data-pricing-quantity]');

      if (!quantity || !this.isQuantitySelectable(quantity)) return;

      event.preventDefault();
      event.stopPropagation();

      this.selectQuantity(quantity, true);
    }

    onQuantityKeydown(event) {
      const currentIndex = this.quantities.indexOf(event.currentTarget);

      if (currentIndex === -1) return;

      let nextIndex = null;

      if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
        event.preventDefault();
        nextIndex = (currentIndex + 1) % this.quantities.length;
      }

      if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
        event.preventDefault();
        nextIndex = (currentIndex - 1 + this.quantities.length) % this.quantities.length;
      }

      if (nextIndex === null) return;

      const nextQuantity = this.quantities[nextIndex];

      if (!this.isQuantitySelectable(nextQuantity)) {
        nextQuantity.focus();
        return;
      }

      this.selectQuantity(nextQuantity, true);
      nextQuantity.focus();
    }

    onPurchaseTypeClick(event) {
      const option = event.currentTarget.closest('[data-pricing-purchase-type]');

      if (!option) return;

      this.purchaseType = option.dataset.pricingPurchaseType === 'onetime' ? 'onetime' : 'subscribe';

      this.purchaseTypes.forEach((item) => {
        const isSelected = item === option;
        item.classList.toggle('is-selected', isSelected);
        item.setAttribute('aria-checked', isSelected ? 'true' : 'false');
      });

      this.root.classList.toggle('is-onetime', this.purchaseType === 'onetime');
      this.updatePurchaseUI();
    }

    selectQuantity(quantity, animate) {
      if (!quantity || !this.isQuantitySelectable(quantity)) return;

      this.quantities.forEach((item) => {
        const isSelected = item === quantity;
        item.classList.toggle('is-selected', isSelected);
        item.setAttribute('aria-checked', isSelected ? 'true' : 'false');
        item.setAttribute('tabindex', isSelected ? '0' : '-1');
      });

      if (animate && window.matchMedia('(prefers-reduced-motion: no-preference)').matches) {
        quantity.animate(
          [
            { transform: 'scale(1)' },
            { transform: 'scale(0.985)' },
            { transform: 'scale(1)' },
          ],
          { duration: 180, easing: 'ease-out' }
        );
      }

      this.updatePurchaseUI();
      this.syncGalleryToSelectedQuantity(animate);
    }

    syncGalleryToSelectedQuantity(fromUser) {
      if (!this.gallery?.tierSyncEnabled) return;

      const quantity = this.getSelectedQuantity();
      if (!quantity) return;

      const galleryIndex = Number(
        quantity.dataset.pricingGalleryIndex ?? quantity.dataset.tierIndex ?? 0
      );

      if (Number.isNaN(galleryIndex)) return;

      this.gallery.setActive(galleryIndex, fromUser);
    }

    getTierData(quantity) {
      if (!quantity) return {};

      return {
        subscribeVariantId: quantity.dataset.subscribeVariantId || quantity.dataset.variantId || '',
        onetimeVariantId: quantity.dataset.onetimeVariantId || quantity.dataset.variantId || '',
        sellingPlanId: quantity.dataset.sellingPlanId || '',
        cartQuantity: Math.max(1, Number(quantity.dataset.cartQuantity || 1)),
        tierLink: quantity.dataset.tierLink || '',
        subscribePrice: quantity.dataset.subscribePrice || '',
        onetimePrice: quantity.dataset.onetimePrice || '',
        subscribeSave: quantity.dataset.subscribeSave || '',
        totalSubscribe: quantity.dataset.totalSubscribe || '',
        totalOnetime: quantity.dataset.totalOnetime || '',
        compareSubscribe: quantity.dataset.compareSubscribe || '',
        compareOnetime: quantity.dataset.compareOnetime || '',
        compareTotalSubscribe: quantity.dataset.compareTotalSubscribe || quantity.dataset.compareSubscribe || '',
        compareTotalOnetime: quantity.dataset.compareTotalOnetime || quantity.dataset.compareOnetime || '',
        shippingSubscribe: quantity.dataset.shippingSubscribe || '',
        shippingOnetime: quantity.dataset.shippingOnetime || '',
        deliveryFrequency: quantity.dataset.deliveryFrequency || '',
        perSupplyLabel: quantity.dataset.perSupplyLabel || 'PER SUPPLY',
        unitPriceSuffix: quantity.dataset.unitPriceSuffix || '',
        perDaySubscribe: quantity.dataset.perDaySubscribe || '',
        perDayOnetime: quantity.dataset.perDayOnetime || '',
        guaranteeDays: Math.max(1, Number(quantity.dataset.guaranteeDays || 30)),
      };
    }

    getActiveVariantId(tier) {
      if (!tier) return '';
      return this.purchaseType === 'subscribe' ? tier.subscribeVariantId : tier.onetimeVariantId;
    }

    syncTierCardPricing() {
      const isSubscribe = this.purchaseType === 'subscribe';

      this.quantities.forEach((quantity) => {
        const tier = this.getTierData(quantity);
        const priceEl = quantity.querySelector('[data-pricing-tier-price]');
        const compareEl = quantity.querySelector('[data-pricing-tier-compare]');
        const perDayEl = quantity.querySelector('[data-pricing-tier-per-day]');
        const saveEl = quantity.querySelector('[data-pricing-tier-save]');

        const total = isSubscribe ? tier.totalSubscribe : tier.totalOnetime;
        const unitPrice = isSubscribe ? tier.subscribePrice : tier.onetimePrice;
        const compare = isSubscribe ? tier.compareTotalSubscribe : tier.compareTotalOnetime;
        const perDay = isSubscribe ? tier.perDaySubscribe : tier.perDayOnetime;
        const heroPrice = total || unitPrice;

        if (priceEl && heroPrice) {
          priceEl.textContent = heroPrice;
        }

        if (compareEl) {
          if (compare) {
            compareEl.textContent = compare;
            compareEl.hidden = false;
          } else {
            compareEl.textContent = '';
            compareEl.hidden = true;
          }
        }

        if (perDayEl) {
          if (perDay) {
            perDayEl.hidden = false;
            perDayEl.innerHTML = `${perDay} <span class="pricing__quantity-per-day-label">${this.perDaySuffix}</span>`;
          } else {
            perDayEl.hidden = true;
            perDayEl.textContent = '';
          }
        }

        if (saveEl) {
          if (isSubscribe && tier.subscribeSave) {
            saveEl.hidden = false;
            saveEl.textContent = this.saveLabelTemplate.replace('__AMOUNT__', tier.subscribeSave);
          } else {
            saveEl.hidden = true;
          }
        }
      });
    }

    updatePurchaseUI() {
      const quantity = this.getSelectedQuantity();
      const tier = this.getTierData(quantity);
      const isSubscribe = this.purchaseType === 'subscribe';

      this.syncTierCardPricing();

      if (this.toggleSubscribeLabel) {
        this.toggleSubscribeLabel.textContent = this.subscribeToggleLabel;
      }

      if (this.toggleSaveHint) {
        if (tier.subscribeSave) {
          this.toggleSaveHint.hidden = false;
          this.toggleSaveHint.textContent = this.saveLabelTemplate.replace('__AMOUNT__', tier.subscribeSave);
        } else {
          this.toggleSaveHint.hidden = true;
          this.toggleSaveHint.textContent = '';
        }
      }

      const totalPrice = isSubscribe
        ? tier.totalSubscribe || tier.subscribePrice
        : tier.totalOnetime || tier.onetimePrice;
      const unitPrice = isSubscribe ? tier.subscribePrice : tier.onetimePrice;

      if (this.displayPrice) {
        this.displayPrice.textContent = totalPrice || '';
      }

      if (this.displayPeriod) {
        if (unitPrice && tier.unitPriceSuffix) {
          this.displayPeriod.hidden = false;
          this.displayPeriod.textContent = `${unitPrice} ${tier.unitPriceSuffix}`;
        } else if (tier.perSupplyLabel) {
          this.displayPeriod.hidden = false;
          this.displayPeriod.textContent = tier.perSupplyLabel;
        } else {
          this.displayPeriod.textContent = '';
          this.displayPeriod.hidden = true;
        }
      }

      if (this.displayPerDay) {
        const perDay = isSubscribe ? tier.perDaySubscribe : tier.perDayOnetime;

        if (perDay) {
          this.displayPerDay.hidden = false;
          this.displayPerDay.textContent = `${perDay} ${this.perDaySuffix}`;
        } else {
          this.displayPerDay.hidden = true;
          this.displayPerDay.textContent = '';
        }
      }

      if (this.benefitsHeading) {
        this.benefitsHeading.textContent = isSubscribe
          ? this.root.dataset.benefitsHeadingSubscribe || 'Subscription benefits'
          : this.root.dataset.benefitsHeadingOnetime || 'You miss with one-time';
      }

      if (this.guaranteeText) {
        this.guaranteeText.textContent = this.guaranteeTextTemplate.replace(
          '__DAYS__',
          String(tier.guaranteeDays)
        );
      }

      this.guaranteeBenefits.forEach((benefit) => {
        const benefitText = benefit.querySelector('[data-pricing-purchase-benefit-text]');

        if (benefitText) {
          benefitText.textContent = (benefit.dataset.pricingGuaranteeBenefitTemplate || '').replace(
            '__DAYS__',
            String(tier.guaranteeDays)
          );
        }
      });

      if (this.submitLabel) {
        this.submitLabel.textContent = isSubscribe ? this.subscribeLabel : this.onetimeLabel;
      }

      if (this.variantInput) {
        this.variantInput.value = this.getActiveVariantId(tier);
      }

      if (this.quantityInput) {
        this.quantityInput.value = String(tier.cartQuantity || 1);
      }

      if (this.sellingPlanInput) {
        this.sellingPlanInput.value = isSubscribe ? tier.sellingPlanId : '';
      }

      if (this.totalLine) {
        const compare = isSubscribe ? tier.compareTotalSubscribe : tier.compareTotalOnetime;
        const total = isSubscribe ? tier.totalSubscribe : tier.totalOnetime;
        const shipping = isSubscribe ? tier.shippingSubscribe : tier.shippingOnetime;

        if (total) {
          let html = `${this.totalLabel}: `;

          if (compare) {
            html += `<s>${compare}</s> `;
          }

          html += `<strong>${total}</strong>`;

          if (shipping) {
            html += ` + ${shipping}`;
          }

          this.totalLine.innerHTML = html;
        } else {
          this.totalLine.textContent = '';
        }
      }

      if (this.submitButton) {
        this.submitButton.disabled = false;
      }
    }

    setLoading(isLoading) {
      if (!this.submitButton) return;

      const quantity = this.getSelectedQuantity();
      const isSubscribe = this.purchaseType === 'subscribe';
      const idleLabel = isSubscribe ? this.subscribeLabel : this.onetimeLabel;

      this.submitButton.disabled = isLoading;
      this.submitButton.classList.toggle('is-loading', isLoading);

      if (this.submitSpinner) {
        this.submitSpinner.hidden = !isLoading;
      }

      if (this.submitLabel) {
        this.submitLabel.textContent = isLoading ? this.addingLabel : idleLabel;
      }
    }

    setStockMessage(message, isSuccess) {
      if (!this.stockNote || !message) return;

      this.stockNote.textContent = message;
      this.stockNote.classList.toggle('is-success', Boolean(isSuccess));
    }

    async onSubmit(event) {
      const quantity = this.getSelectedQuantity();

      if (!quantity) return;

      const tier = this.getTierData(quantity);
      const isSubscribe = this.purchaseType === 'subscribe';

      if (tier.tierLink) {
        event.preventDefault();
        window.location.href = tier.tierLink;
        return;
      }

      if (!this.getActiveVariantId(tier)) {
        event.preventDefault();

        if (this.fallbackLink) {
          window.location.href = this.fallbackLink;
        }

        return;
      }

      event.preventDefault();
      this.setLoading(true);

      const item = {
        id: Number(this.getActiveVariantId(tier)),
        quantity: tier.cartQuantity || 1,
      };

      if (isSubscribe && tier.sellingPlanId) {
        item.selling_plan = Number(tier.sellingPlanId);
      }

      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({ items: [item] }),
        });

        const payload = await response.json();

        if (!response.ok) {
          throw new Error(payload?.description || payload?.message || 'Cart error');
        }

        this.setStockMessage(this.addedLabel, true);

        const cartResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
          headers: { Accept: 'application/json' },
        });
        const cart = cartResponse.ok ? await cartResponse.json() : null;

        if (cart) {
          document.dispatchEvent(
            new CustomEvent('cart:updated', {
              detail: {
                cart,
                open: this.afterAdd === 'drawer',
              },
            })
          );
        } else if (this.afterAdd === 'drawer') {
          document.dispatchEvent(new CustomEvent('cart:open'));
        }

        if (this.afterAdd === 'drawer') {
          this.setLoading(false);

          if (this.submitLabel) {
            this.submitLabel.textContent = this.addedLabel;
            window.setTimeout(() => this.updatePurchaseUI(), 1800);
          }
          return;
        }

        if (this.afterAdd === 'cart') {
          window.location.href = `${window.Shopify?.routes?.root || '/'}cart`;
          return;
        }

        if (this.afterAdd === 'checkout') {
          window.location.href = '/checkout';
          return;
        }

        this.setLoading(false);

        if (this.submitLabel) {
          this.submitLabel.textContent = this.addedLabel;
          window.setTimeout(() => this.updatePurchaseUI(), 1800);
        }
      } catch (error) {
        this.setLoading(false);
        this.setStockMessage(this.errorLabel, false);
      }
    }

    disconnect() {
      this.quantities.forEach((quantity) => {
        quantity.removeEventListener('click', this.onQuantityClick);
        quantity.removeEventListener('keydown', this.onQuantityKeydown);
      });

      this.purchaseTypes.forEach((option) => {
        option.removeEventListener('click', this.onPurchaseTypeClick);
      });

      if (this.form) {
        this.form.removeEventListener('submit', this.onSubmit);
      }
    }
  }

  const pricingBuyboxes = new WeakMap();

  function initPricingBuyboxes() {
    document.querySelectorAll('[data-pricing-buybox]').forEach((root) => {
      if (pricingBuyboxes.has(root)) {
        pricingBuyboxes.get(root).disconnect();
      }

      const section = root.closest('.pricing-section');
      const gallery = section ? pricingGalleries.get(section) : null;

      pricingBuyboxes.set(root, new PricingBuybox(root, gallery));
    });
  }

  initPricingStickyGalleries();
  initPricingGalleries();
  initPricingBuyboxes();
  document.addEventListener('shopify:section:load', () => {
    initPricingStickyGalleries();
    initPricingGalleries();
    initPricingBuyboxes();
  });
  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target;

    if (pricingStickyGalleries.has(section)) {
      pricingStickyGalleries.get(section).disconnect();
      pricingStickyGalleries.delete(section);
    }

    if (pricingGalleries.has(section)) {
      pricingGalleries.get(section).disconnect();
      pricingGalleries.delete(section);
    }

    const root = section.querySelector('[data-pricing-buybox]');

    if (root && pricingBuyboxes.has(root)) {
      pricingBuyboxes.get(root).disconnect();
      pricingBuyboxes.delete(root);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["results-timeline"] && !Shopify.designMode) return;
  try {
    
  class ResultsTimelineSection {
    constructor(section) {
      this.section = section;
      this.header = section.querySelector('[data-timeline-header]');
      this.track = section.querySelector('[data-timeline-track]');
      this.progress = section.querySelector('[data-timeline-progress]');
      this.milestones = Array.from(section.querySelectorAll('[data-timeline-milestone]'));
      this.dots = Array.from(section.querySelectorAll('[data-timeline-dot]'));
      this.mobileNav = section.querySelector('[data-timeline-mobile-nav]');
      this.scrollHint = section.querySelector('[data-timeline-scroll-hint]');
      this.desktopQuery = window.matchMedia('(min-width: 990px)');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.observer = null;
      this.headerObserver = null;
      this.activeIndex = 0;
      this.mode = null;

      if (!this.milestones.length) return;

      this.bindDots();
      this.setMode();

      this.desktopQuery.addEventListener('change', this.setMode);
      this.reducedMotion.addEventListener('change', this.setMode);
      window.addEventListener('resize', this.handleResize);
    }

    setMode = () => {
      const nextMode = this.desktopQuery.matches ? 'desktop' : 'mobile';

      if (nextMode === this.mode) {
        this.handleResize();
        return;
      }

      this.teardown();
      this.mode = nextMode;

      if (this.mode === 'desktop') {
        this.initDesktop();
      } else {
        this.initMobile();
      }
    };

    initDesktop() {
      if (this.mobileNav) {
        this.mobileNav.setAttribute('aria-hidden', 'true');
      }

      if (this.scrollHint) {
        this.scrollHint.setAttribute('aria-hidden', 'true');
        this.scrollHint.classList.add('is-hidden');
      }

      this.revealAll();
    }

    initMobile() {
      if (this.mobileNav) {
        this.mobileNav.setAttribute('aria-hidden', 'false');
      }

      if (this.scrollHint) {
        this.scrollHint.setAttribute('aria-hidden', 'true');
        this.scrollHint.classList.add('is-hidden');
      }

      if (this.reducedMotion.matches) {
        this.revealAll();
        return;
      }

      this.milestones.forEach((milestone) => {
        milestone.classList.remove('is-revealed', 'is-visible');
      });

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            entry.target.classList.add('is-revealed');
          });

          this.syncActiveFromScroll();
        },
        {
          threshold: [0.35, 0.55, 0.75],
          rootMargin: '-10% 0px -20% 0px',
        }
      );

      if (this.header) {
        const headerObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('is-visible');
              headerObserver.unobserve(entry.target);
            });
          },
          { threshold: 0.2 }
        );
        headerObserver.observe(this.header);
        this.headerObserver = headerObserver;
      }

      this.milestones.forEach((milestone, index) => {
        milestone.style.transitionDelay = `${index * 80}ms`;
        this.observer.observe(milestone);
      });

      this.setActive(1);
    }

    bindDots() {
      this.dots.forEach((dot) => {
        dot.addEventListener('click', this.handleDotClick);
      });
    }

    handleDotClick = (event) => {
      const dot = event.currentTarget;
      const index = Number(dot.dataset.timelineDot);
      const milestone = this.milestones[index - 1];
      if (!milestone) return;

      milestone.scrollIntoView({ behavior: 'smooth', block: 'center' });
      this.setActive(index);
    };

    syncActiveFromScroll() {
      const visible = this.milestones
        .map((milestone, index) => {
          const rect = milestone.getBoundingClientRect();
          const viewportMiddle = window.innerHeight * 0.45;
          const distance = Math.abs(rect.top + rect.height / 2 - viewportMiddle);
          return { index: index + 1, distance, visible: rect.bottom > 0 && rect.top < window.innerHeight };
        })
        .filter((item) => item.visible)
        .sort((a, b) => a.distance - b.distance);

      if (visible.length) {
        this.setActive(visible[0].index);
      }
    }

    setActive(index) {
      this.activeIndex = index;
      this.milestones.forEach((milestone, milestoneIndex) => {
        milestone.classList.toggle('is-active', milestoneIndex + 1 === index);
      });
      this.dots.forEach((dot) => {
        dot.classList.toggle('is-active', Number(dot.dataset.timelineDot) === index);
      });
      this.updateMobileProgress();
    }

    updateMobileProgress() {
      if (this.mode === 'desktop' || !this.progress || !this.milestones.length) return;

      const ratio = this.activeIndex / this.milestones.length;
      const track = this.track?.querySelector('.results-timeline__track-rail');
      const trackHeight = track?.offsetHeight || 0;
      this.progress.style.height = `${trackHeight * ratio}px`;
      this.progress.style.width = '4px';
    }

    handleResize = () => {
      if (this.mode === 'mobile') {
        this.updateMobileProgress();
      }
    };

    revealAll() {
      this.header?.classList.add('is-visible');
      this.milestones.forEach((milestone) => {
        milestone.classList.add('is-visible');
        milestone.classList.add('is-revealed');
      });
      this.setActive(this.milestones.length);
      if (this.progress) {
        this.progress.style.width = '100%';
        if (this.mode === 'mobile') {
          this.updateMobileProgress();
        }
      }
    }

    teardown() {
      this.observer?.disconnect();
      this.observer = null;
      this.headerObserver?.disconnect();
      this.headerObserver = null;

      this.milestones.forEach((milestone) => {
        milestone.classList.remove('is-visible', 'is-revealed', 'is-active');
        milestone.style.transitionDelay = '';
      });

      if (this.progress) {
        this.progress.style.width = this.mode === 'desktop' ? '100%' : '0';
        this.progress.style.height = '4px';
      }
    }

    disconnect() {
      this.teardown();
      this.desktopQuery.removeEventListener('change', this.setMode);
      this.reducedMotion.removeEventListener('change', this.setMode);
      window.removeEventListener('resize', this.handleResize);
      this.dots.forEach((dot) => dot.removeEventListener('click', this.handleDotClick));
    }
  }

  const resultsTimelineSections = new WeakMap();

  function initResultsTimelineSections() {
    document.querySelectorAll('.results-timeline').forEach((section) => {
      if (resultsTimelineSections.has(section)) {
        resultsTimelineSections.get(section).disconnect();
      }

      resultsTimelineSections.set(section, new ResultsTimelineSection(section));
    });
  }

  initResultsTimelineSections();
  document.addEventListener('shopify:section:load', initResultsTimelineSections);
  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target.querySelector('.results-timeline');

    if (section && resultsTimelineSections.has(section)) {
      resultsTimelineSections.get(section).disconnect();
      resultsTimelineSections.delete(section);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const storagePrefix = 'reviews-helpful-';

    function parseDate(value) {
      if (!value) return 0;
      const timestamp = Date.parse(value);
      return Number.isNaN(timestamp) ? 0 : timestamp;
    }

    class ReviewsSection {
      constructor(root) {
        this.root = root;
        this.perPage = Number(root.dataset.reviewsPerPage) || 5;
        this.readLessLabel = root.dataset.readLess || 'Read less';
        this.items = Array.from(root.querySelectorAll('[data-review-item]'));
        this.searchInput = root.querySelector('[data-reviews-search]');
        this.sortSelect = root.querySelector('[data-reviews-sort]');
        this.topicButtons = Array.from(root.querySelectorAll('[data-reviews-topic]'));
        this.topicsToggle = root.querySelector('[data-reviews-topics-toggle]');
        this.emptyState = root.querySelector('[data-reviews-empty]');
        this.pagination = root.querySelector('[data-reviews-pagination]');
        this.list = root.querySelector('[data-reviews-list]');
        this.activeTopic = '';
        this.currentPage = 1;

        this.bindEvents();
        this.restoreHelpfulVotes();
        this.applyFilters();
      }

      bindEvents() {
        if (this.searchInput) {
          this.searchInput.addEventListener('input', () => {
            this.currentPage = 1;
            this.applyFilters();
          });
        }

        if (this.sortSelect) {
          this.sortSelect.value = this.root.dataset.defaultSort || 'rating_desc';
          this.sortSelect.addEventListener('change', () => {
            this.currentPage = 1;
            this.applyFilters();
          });
        }

        this.topicButtons.forEach((button) => {
          button.addEventListener('click', () => {
            const topic = button.dataset.topic || '';
            this.activeTopic = this.activeTopic === topic ? '' : topic;
            this.topicButtons.forEach((item) => {
              item.classList.toggle('is-active', item.dataset.topic === this.activeTopic);
            });
            this.currentPage = 1;
            this.applyFilters();
          });
        });

        if (this.topicsToggle) {
          this.topicsToggle.addEventListener('click', () => {
            const hiddenTopics = this.root.querySelectorAll('.reviews__topic.is-hidden');
            hiddenTopics.forEach((topic) => topic.classList.remove('is-hidden'));
            this.topicsToggle.hidden = true;
          });
        }

        this.root.addEventListener('click', (event) => {
          const readMore = event.target.closest('[data-review-read-more]');
          if (readMore) {
            this.toggleReadMore(readMore);
            return;
          }

          const helpfulUp = event.target.closest('[data-helpful-up]');
          if (helpfulUp) {
            this.voteHelpful(helpfulUp, 'up');
            return;
          }

          const helpfulDown = event.target.closest('[data-helpful-down]');
          if (helpfulDown) {
            this.voteHelpful(helpfulDown, 'down');
          }
        });

        if (this.pagination) {
          this.pagination.addEventListener('click', (event) => {
            const button = event.target.closest('[data-page]');
            if (!button || button.disabled) return;

            const page = Number(button.dataset.page);
            const totalPages = Math.max(1, Math.ceil(this.getFilteredItems().length / this.perPage));
            if (page < 1 || page > totalPages) return;

            this.currentPage = page;
            this.applyFilters();
            this.root.scrollIntoView({ behavior: 'smooth', block: 'start' });
          });
        }
      }

      getFilteredItems() {
        const query = (this.searchInput?.value || '').trim().toLowerCase();
        const sortValue = this.sortSelect?.value || 'rating_desc';

        let filtered = this.items.filter((item) => {
          const searchBlob = item.dataset.search || '';
          const topics = item.dataset.topics || '';
          const matchesSearch = !query || searchBlob.includes(query);
          const matchesTopic = !this.activeTopic || topics.includes(this.activeTopic) || searchBlob.includes(this.activeTopic);
          return matchesSearch && matchesTopic;
        });

        filtered.sort((a, b) => {
          const ratingA = Number(a.dataset.rating) || 0;
          const ratingB = Number(b.dataset.rating) || 0;
          const dateA = parseDate(a.dataset.date);
          const dateB = parseDate(b.dataset.date);

          if (sortValue === 'rating_desc') {
            if (ratingB !== ratingA) return ratingB - ratingA;
            return dateB - dateA;
          }
          if (sortValue === 'rating_asc') {
            if (ratingA !== ratingB) return ratingA - ratingB;
            return dateA - dateB;
          }
          if (sortValue === 'date_desc') {
            if (dateB !== dateA) return dateB - dateA;
            return ratingB - ratingA;
          }
          if (dateA !== dateB) return dateA - dateB;
          return ratingA - ratingB;
        });

        return filtered;
      }

      reorderList(orderedItems) {
        if (!this.list || orderedItems.length === 0) return;

        const orderedIds = new Set(orderedItems.map((item) => item.dataset.reviewId));
        const remainingItems = this.items.filter((item) => !orderedIds.has(item.dataset.reviewId));

        this.list.querySelectorAll('.reviews__divider').forEach((divider) => divider.remove());

        orderedItems.forEach((item, index) => {
          this.list.appendChild(item);

          if (index < orderedItems.length - 1) {
            const divider = document.createElement('hr');
            divider.className = 'reviews__divider';
            divider.setAttribute('aria-hidden', 'true');
            this.list.appendChild(divider);
          }
        });

        remainingItems.forEach((item) => {
          this.list.appendChild(item);
        });
      }

      applyFilters() {
        const filtered = this.getFilteredItems();
        this.reorderList(filtered);
        const totalPages = Math.max(1, Math.ceil(filtered.length / this.perPage));
        if (this.currentPage > totalPages) this.currentPage = totalPages;

        const start = (this.currentPage - 1) * this.perPage;
        const end = start + this.perPage;
        const visibleIds = new Set(filtered.slice(start, end).map((item) => item.dataset.reviewId));

        this.items.forEach((item) => {
          item.classList.toggle('is-hidden', !visibleIds.has(item.dataset.reviewId));
        });

        this.items.forEach((item) => {
          const divider = item.nextElementSibling;
          if (divider && divider.classList.contains('reviews__divider')) {
            const nextItem = divider.nextElementSibling;
            const hideDivider = item.classList.contains('is-hidden')
              || !nextItem
              || !nextItem.matches('[data-review-item]')
              || nextItem.classList.contains('is-hidden');
            divider.classList.toggle('is-hidden', hideDivider);
          }
        });

        if (this.emptyState) {
          this.emptyState.hidden = filtered.length > 0;
        }

        this.renderPagination(totalPages);
      }

      renderPagination(totalPages) {
        if (!this.pagination) return;
        this.pagination.innerHTML = '';

        if (totalPages <= 1) return;

        const prev = document.createElement('button');
        prev.type = 'button';
        prev.className = 'reviews__page-btn';
        prev.dataset.page = String(this.currentPage - 1);
        prev.disabled = this.currentPage === 1;
        prev.setAttribute('aria-label', 'Previous page');
        prev.innerHTML = '<svg viewBox="0 0 7 11" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.703 9.176L2.83 5.293L6.703 1.41L5.293 0L0 5.293L5.293 10.586L6.703 9.176Z" fill="currentColor"/></svg>';
        this.pagination.appendChild(prev);

        for (let page = 1; page <= totalPages; page += 1) {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'reviews__page-btn';
          if (page === this.currentPage) button.classList.add('is-active');
          button.dataset.page = String(page);
          button.textContent = String(page);
          button.setAttribute('aria-label', `Page ${page}`);
          button.setAttribute('aria-current', page === this.currentPage ? 'page' : 'false');
          this.pagination.appendChild(button);
        }

        const next = document.createElement('button');
        next.type = 'button';
        next.className = 'reviews__page-btn';
        next.dataset.page = String(this.currentPage + 1);
        next.disabled = this.currentPage === totalPages;
        next.setAttribute('aria-label', 'Next page');
        next.innerHTML = '<svg viewBox="0 0 7 11" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M0 9.176L3.873 5.293L0 1.41L1.41 0L6.703 5.293L1.41 10.586L0 9.176Z" fill="currentColor"/></svg>';
        this.pagination.appendChild(next);
      }

      toggleReadMore(button) {
        const content = button.closest('[data-review-content]');
        if (!content) return;

        const preview = content.querySelector('[data-review-preview]');
        const full = content.querySelector('[data-review-full]');
        const expanded = content.classList.toggle('is-expanded');

        if (preview) preview.hidden = expanded;
        if (full) full.hidden = !expanded;
        button.textContent = expanded ? this.readLessLabel : (button.dataset.readMore || 'Read more');
      }

      voteHelpful(button, direction) {
        const item = button.closest('[data-review-item]');
        if (!item) return;

        const reviewId = item.dataset.reviewId;
        const storageKey = storagePrefix + reviewId;
        if (sessionStorage.getItem(storageKey)) return;

        const upButton = item.querySelector('[data-helpful-up]');
        const downButton = item.querySelector('[data-helpful-down]');
        const upCount = item.querySelector('[data-helpful-up-count]');
        const downCount = item.querySelector('[data-helpful-down-count]');

        if (direction === 'up' && upCount) {
          upCount.textContent = String(Number(upCount.textContent) + 1);
        }

        if (direction === 'down' && downCount) {
          downCount.textContent = String(Number(downCount.textContent) + 1);
        }

        if (upButton) upButton.disabled = true;
        if (downButton) downButton.disabled = true;
        sessionStorage.setItem(storageKey, direction);
      }

      restoreHelpfulVotes() {
        this.items.forEach((item) => {
          const reviewId = item.dataset.reviewId;
          if (!sessionStorage.getItem(storagePrefix + reviewId)) return;

          const upButton = item.querySelector('[data-helpful-up]');
          const downButton = item.querySelector('[data-helpful-down]');
          if (upButton) upButton.disabled = true;
          if (downButton) downButton.disabled = true;
        });
      }
    }

    function initReviews(root) {
      if (!root || root.dataset.reviewsInitialized === 'true') return;
      root.dataset.reviewsInitialized = 'true';
      new ReviewsSection(root);
    }

    document.querySelectorAll('[data-reviews]').forEach(initReviews);
    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector('[data-reviews]');
      initReviews(section);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
